// Where the engine endpoints actually live.
//
// This existed as one helper, `tripFunctionUrl(tripId, path)`, building
// `/functions/v1/trips/<id><path>` — a REST shape that was never deployed. Supabase routes
// by the FIRST path segment, so every one of those calls invoked the `trips` function,
// which only accepts POST and answered 405. All three engine calls were broken, and
// silently: /windows and /regions were unreachable without a hand-typed ?trip=, so nobody
// hit the buttons.
//
// Hence one tested module. Each function returns the URL and body the deployed function
// actually expects, and the two conventions differ — windows takes a path param, the
// regions endpoints take trip_id in the body.

export interface EdgeCall {
  url: string
  /** Already serialized; undefined for GET. */
  body?: string
}

/** GET/POST /functions/v1/windows/:tripId */
export function windowsCall(base: string, tripId: string): EdgeCall {
  return { url: `${base}/windows/${encodeURIComponent(tripId)}` }
}

/** POST /functions/v1/regions-propose { trip_id } */
export function regionsProposeCall(base: string, tripId: string): EdgeCall {
  return { url: `${base}/regions-propose`, body: JSON.stringify({ trip_id: tripId }) }
}

/** POST /functions/v1/regions-score { trip_id } */
export function regionsScoreCall(base: string, tripId: string): EdgeCall {
  return { url: `${base}/regions-score`, body: JSON.stringify({ trip_id: tripId }) }
}
